import { OLTypeEnum } from '../../types/enums/ol/ol-type.enum'
import { OlFilters } from '../../types/models/ol/ol'

export const transformOlFiltersToUrl = (filters?: OlFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.isActive !== undefined) searchParams.set('isActive', filters.isActive.toString())
  if (filters.types) searchParams.set('types', filters.types.join(','))
  if (filters.contactInParisIds)
    searchParams.set('contactInParisIds', filters.contactInParisIds.join(','))
  if (filters.countries) searchParams.set('countries', filters.countries.join(','))

  return searchParams.toString()
}

export const transformUrlToOlFilters = (searchParams: URLSearchParams): OlFilters => {
  const filters: OlFilters = {}

  const isActive = searchParams.get('isActive')
  if (isActive) filters.isActive = isActive === 'true'

  const types = searchParams.get('types')
  if (types) filters.types = types.split(',') as OLTypeEnum[]

  const contactInParisIds = searchParams.get('contactInParisIds')
  if (contactInParisIds) filters.contactInParisIds = contactInParisIds.split(',').map(Number)

  const countries = searchParams.get('countries')
  if (countries) filters.countries = countries.split(',')

  return filters
}
